module.exports = __webpack_public_path__ + "img/monthly-budget-planner_B09QP2MFSV.06a74f87.jpg";